module.exports = __webpack_public_path__ + "img/ic-playlists-hover.9c110941.svg";